import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  removeOrderSourceHeader: {
    defaultMessage: 'Remove order source',
    description: 'Header for the remove order source modal',
    id: 'HMx7Yf',
  },
  planLimitWarning: {
    defaultMessage:
      'Your current plan allows {maxAllowedOrderSources, plural, one {one active order source} other {# active order sources}}',
    description: 'Warning message about plan order source limit',
    id: 'HGzBaX',
  },
  deactivateInstructions: {
    defaultMessage:
      'To continue using ShipStation, please deactivate all {maxAllowedOrderSources, plural, =0 {order sources} one {but one order source} other {but # order sources}} to stay within your plan limits or upgrade your subscription.',
    description: 'Instructions to deactivate order sources to stay within plan limits',
    id: 'b4/PxI',
  },
  upgradeButton: {
    defaultMessage: 'Upgrade',
    description: 'Button text to upgrade plan',
    id: '44JnjH',
  },
  maxAllowedOrderSources: {
    defaultMessage: 'Max allowed order sources: {maxAllowedOrderSources}',
    description: 'Label for maximum allowed order sources',
    id: 'AyAXyD',
  },
  currentActiveOrderSources: {
    defaultMessage: 'Current active order sources: {currentActiveOrderSources}',
    description: 'Label for current active order sources count',
    id: '/jkS+y',
  },
  storeNameHeader: {
    defaultMessage: 'Store Name',
    description: 'Store name column header in order sources table',
    id: 'VVhj/6',
  },
  lastModifiedHeader: {
    defaultMessage: 'Last modified',
    description: 'Last modified column header in order sources table',
    id: '3q/W0C',
  },
  statusHeader: {
    defaultMessage: 'Status',
    description: 'Status column header in order sources table',
    id: 'FIv1NB',
  },
  actionsHeader: {
    defaultMessage: 'Actions',
    description: 'Actions column header in order sources table',
    id: 'FuXNHN',
  },
  deactivateAction: {
    defaultMessage: 'Deactivate',
    description: 'Deactivate button text',
    id: '1uMOk+',
  },
  reactivateAction: {
    defaultMessage: 'Reactivate',
    description: 'Reactivate button text',
    id: 'kHOrvf',
  },
  continueButton: {
    defaultMessage: 'Continue',
    description: 'Continue button text',
    id: '3s73DJ',
  },
  activeStatus: {
    defaultMessage: 'Active',
    description: 'Label for active status in order sources table',
    id: 'tekp7W',
  },
  inactiveStatus: {
    defaultMessage: 'Inactive',
    description: 'Label for inactive status in order sources table',
    id: 'adqbUk',
  },
  unlimited: {
    defaultMessage: 'Unlimited',
    description: 'Label for unlimited order sources',
    id: '/Zr20v',
  },
});

export default messages;
